// reducers/closureReducer.js
import {
  SUBMIT_CLOSURE_REQUEST,
  SUBMIT_CLOSURE_SUCCESS,
  SUBMIT_CLOSURE_FAILURE,
} from "../actions/closureAgentActions";

const initialState = {
  loading: false,
  successMessage: null,
  errorMessage: null,
};

const closureReducer = (state = initialState, action) => {
  switch (action.type) {
    case SUBMIT_CLOSURE_REQUEST:
      return {
        ...state,
        loading: true,
        successMessage: null,
        errorMessage: null,
      };
    case SUBMIT_CLOSURE_SUCCESS:
      return {
        ...state,
        loading: false,
        successMessage: action.payload,
        errorMessage: null,
      };
    case SUBMIT_CLOSURE_FAILURE:
      return {
        ...state,
        loading: false,
        successMessage: null,
        errorMessage: action.payload,
      };
    default:
      return state;
  }
};

export default closureReducer;
